import { ResourcesState } from 'entities/hallmap/model/types';

export const isResourceState = (resource: any): resource is ResourcesState => {
	return 'is_active' in resource && 'state' in resource;
};
